import { z } from 'zod';

export const shopifyAdminApiProductionSchema = z.object({
  us: z.string(),
  au: z.string(),
  nz: z.string(),
  eu: z.string(),
  uk: z.string(),
  qa: z.string(),
  aud: z.string(),
  nzd: z.string(),
  dev: z.string(),
  eud: z.string(),
  ukd: z.string()
});

export const shopifyAdminApiDevSchema = z.object({
  us: z.string().optional(),
  nz: z.string().optional(),
  au: z.string().optional(),
  eu: z.string().optional(),
  uk: z.string().optional(),
  dev: z.string(),
  qa: z.string(),
  aud: z.string(),
  nzd: z.string(),
  eud: z.string(),
  ukd: z.string()
});
